import { Link } from "react-router-dom";
import { Plus, Check, ArrowUpRight } from "lucide-react";
import { useStore } from "@/context/StoreContext";
import { toast } from "sonner";

export default function ProductCard({ product, index = 0 }) {
  const { addToList, inList } = useStore();
  const added = inList(product.id);

  return (
    <div data-testid={`product-card-${product.id}`} className="group flex flex-col">
      <Link to={`/product/${product.id}`} data-testid={`product-card-link-${product.id}`} className="relative block overflow-hidden bg-charcoal aspect-[4/5]">
        <img
          src={product.image}
          alt={product.name}
          loading="lazy"
          className="w-full h-full object-cover opacity-90 transition-transform duration-[1.2s] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.06]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#121212]/80 via-transparent to-transparent" />
        <div className="absolute top-4 left-4 text-[10px] font-mono uppercase tracking-[0.25em] text-ivory/80 bg-[#121212]/60 backdrop-blur-sm px-2.5 py-1">
          {String(index + 1).padStart(2, "0")}
        </div>
        {product.custom_branding && (
          <div className="absolute top-4 right-4 text-[10px] font-mono uppercase tracking-[0.2em] text-charcoal bg-champagne px-2.5 py-1">
            Brandable
          </div>
        )}
        <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between opacity-0 translate-y-3 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500">
          <span className="text-[11px] font-mono uppercase tracking-[0.2em] text-ivory">View Details</span>
          <ArrowUpRight size={16} className="text-champagne" />
        </div>
      </Link>
      <div className="pt-5 flex flex-col flex-1">
        <p className="text-[10px] font-mono uppercase tracking-[0.25em] text-champagne mb-1.5">{product.brand}</p>
        <Link to={`/product/${product.id}`} className="font-serif text-xl leading-snug text-ivory hover:text-champagne-light transition-colors">
          {product.name}
        </Link>
        <p className="text-sm text-ivory/45 mt-2 line-clamp-2 flex-1">{product.short_description}</p>
        <p className="text-[11px] font-mono uppercase tracking-[0.2em] text-ivory/60 mt-4">Price on Request</p>
        <div className="flex gap-2 mt-4">
          <Link
            to={`/request-quote?product=${product.id}`}
            data-testid={`product-request-quote-${product.id}`}
            className="flex-1 text-center text-[10px] font-mono uppercase tracking-[0.18em] bg-ivory text-charcoal px-3 py-3 hover:bg-champagne transition-colors duration-300"
          >
            Request Quote
          </Link>
          <button
            data-testid={`product-add-to-list-${product.id}`}
            onClick={() => {
              if (added) return;
              addToList(product);
              toast.success(`${product.name} added to your gifting list`);
            }}
            aria-label={added ? "Added to gifting list" : "Add to gifting list"}
            className={`px-3.5 border transition-colors duration-300 ${
              added ? "border-champagne text-champagne" : "border-white/20 text-ivory hover:border-champagne hover:text-champagne"
            }`}
          >
            {added ? <Check size={15} /> : <Plus size={15} />}
          </button>
        </div>
      </div>
    </div>
  );
}
